'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewSearchPageComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewSearchPageComponent, _Component);

  function NewSearchPageComponent() {
    (0, _classCallCheck3.default)(this, NewSearchPageComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewSearchPageComponent).call(this));

    _this.onBtnSearch = function () {
      if (_this.refs.SearchInput.value) {
        // console.log(this.refs.SearchInput.value);
      }
    };

    _this.state = {
      showFilter: ''
    };
    return _this;
  }

  (0, _createClass3.default)(NewSearchPageComponent, [{
    key: 'onHeaderBtnClick',
    value: function onHeaderBtnClick() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./NewSearchPageComponent.scss');
      var _props = this.props;
      var headerArray = _props.headerArray;
      var datas = _props.datas;
      /*
       const {showFilter} = this.state;
       let currentData = [];
       if (data instanceof Array && data.length > 0) {
       if (!showFilter) {
       currentData = data;
       } else {
       if (showFilter === 'TSQY') {
       data.forEach((singleData)=> {
       if (singleData.isAreaOrFactory === '1') {
       currentData.push({
       ...singleData
       });
       }
       });
       } else if (showFilter === 'TSGC') {
       data.forEach((singleData)=> {
       if (singleData.isAreaOrFactory === '2') {
       currentData.push({
       ...singleData
       });
       }
       });
       }
       }
       } */

      return _react2.default.createElement(
        'div',
        { className: styles.contentLeftMenu },
        _react2.default.createElement('div', { className: styles.contentLeftMenuBlack }),
        _react2.default.createElement(
          'div',
          { className: styles.contentleftMenuScroll },
          _react2.default.createElement(
            'div',
            { className: styles.scrollTopSearch },
            _react2.default.createElement(
              'div',
              { className: styles.searchBox },
              _react2.default.createElement(
                'div',
                { className: styles.searchInput },
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-search.png', alt: '' })
                ),
                _react2.default.createElement('input', { ref: 'SearchInput', type: 'text', placeholder: '请输入搜索内容' })
              ),
              _react2.default.createElement(
                'button',
                { onClick: this.onBtnSearch, type: 'button' },
                '搜索'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.scrollContext },
            _react2.default.createElement(
              'ul',
              { className: styles.scrollContextUl },
              headerArray.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { className: styles['back' + (index + 1)],
                    onClick: _this2.onHeaderBtnClick.bind(_this2) },
                  item.text
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.scrollContextDiv },
              _react2.default.createElement(
                'dd',
                { className: styles.scrollContextDd },

                /*  [0, 1, 2, 3, 4, 5, 6, 7].map((index)=>
                 <dl key={index}>
                 <div className={styles.dlBack}></div>
                 <a><img
                 src="http://tupian.goeasy.cn:9999/yipinwang/header//logo_a.png" alt=""/></a>
                 <p>
                 <span>东阳中国木雕城坐落于"中国木雕之都"——浙江东阳，占地210亩，市场面积41万平方米。</span>
                 <span>东阳中国木雕城自2009年转型升级以来，市场交易繁荣，发展势头强劲，一跃成为国内最大
                 的木制工艺品和木雕(红木)家具批发市场!中国工艺美术学会木雕艺术专业委员会、浙江省木
                 雕红木家具产品质量检验中心、东阳木雕地理证明商标使用办公室等行业权威机构均常驻市场办公。</span>
                 </p>
                 </dl>)
                 */
                datas instanceof Array && datas.length > 0 ? datas.map(function (item) {
                  return _react2.default.createElement(
                    'dl',
                    { key: item.id },
                    _react2.default.createElement('div', { className: styles.dlBack }),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/characteristicregionalstore/' + item.id },
                      _react2.default.createElement('img', { src: item.logo, alt: '' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.name
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      item.introduce
                    )
                  );
                }) : ''
              )
            )
          )
        )
      );
    }
  }]);
  return NewSearchPageComponent;
}(_react.Component), _class.propTypes = {
  datas: _react.PropTypes.array,
  headerArray: _react.PropTypes.array
}, _temp);
exports.default = NewSearchPageComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewSearchPageComponent/NewSearchPageComponent.js
 ** module id = 1380
 ** module chunks = 0
 **/